import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'The Best Way to Ship Golf Clubs | 4M+ Golf Bags Shipped',
  alternates: {
    canonical: 'https://www.shipsticks.com',
  },
  description:
    'Ship your golf clubs ahead with ShipSticks and skip the airport stress. ' +
    'Enjoy savings up to 60% lower than regular carrier costs.',
  openGraph: {
    type: 'website',
    url: 'https://www.shipsticks.com/',
    siteName: 'ShipSticks',
    title: 'ShipSticks: Ship Golf Clubs Door-to-Door',
    description:
      'Ship your golf clubs ahead with ShipSticks and skip the airport stress. ' +
      'Enjoy savings up to 60% lower than regular carrier costs.',
    images: [
      {
        url: 'https://media.shipsticks.com/ship-sticks-og-image.png',
        width: 1200,
        height: 630,
        alt: 'ShipSticks golf club shipping service',
      },
    ],
  },
}

export default metadata
